import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export const SELLER_SCOPES = [
    { key: "INTERNAL", translationKey: "sellers.scope.internal" },
    { key: "HOME", translationKey: "sellers.scope.oliviaHome" },
];

export const SellerScopeSelect = (props) => {
    const { label, selectedScope, setSelectedScope, disabled = false } = props;
    const { t } = useTranslation();

    return (
        <TextField
            select
            label={label}
            fullWidth
            value={selectedScope}
            onChange={(e) => setSelectedScope(e.target.value)}
            disabled={disabled}
            SelectProps={{
                sx: { textAlign: "left" },
            }}
        >
            {SELLER_SCOPES.map((scope) => (
                <MenuItem key={scope.key} value={scope.key}>
                    {t(scope.translationKey)}
                </MenuItem>
            ))}
        </TextField>
    );
};
